/*
 * Copyright (c) 2019. World Wide Generation Ltd
 */

import { BaseApi } from './BaseApi';

export class MetricUnitApi extends BaseApi {
  endPoint: string = '/api/admin/metric-units';
}
